module.exports = __webpack_public_path__ + "img/20180815_151629_188.f9c70f4c.jpg";